import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import { graphql, useStaticQuery } from 'gatsby';

import React from 'react';
import SingleBlogCard from './single-blog-card';

const RelatedPost = () => {
  const data = useStaticQuery(graphql`
    query AllRelatedPosts {
      allWpPost {
        nodes {
          featuredImage {
            node {
              sourceUrl
            }
          }
          id
          date(formatString: "D MMMM YYYY")
          title
          excerpt
          uri
          slug
          tags {
            nodes {
              name
              slug
            }
          }
          categories {
            nodes {
              name
              description
            }
          }
          language {
            code
          }
        }
      }
    }
  `);

  function shuffleArray(array: any) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  const currentPath =
    typeof window !== 'undefined' ? window.location.pathname : '';
  const isEnglish = currentPath.includes('/en/');

  // Filter posts by language code
  const filteredPosts = data.allWpPost.nodes.filter((post: any) =>
    isEnglish ? post.language.code === 'EN' : post.language.code === 'SR'
  );

  const shuffledPosts = shuffleArray(filteredPosts);

  return (
    <Box maxW={{ base: '100%', md: '480px' }}>
      <Text fontSize="24px" fontWeight="700" color="#26252C" pb="20px">
        {isEnglish ? 'Related articles' : 'Повезани чланци'}
      </Text>
      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 1, xl: 1 }}
        gap={{ base: '12px', lg: '12px' }}
      >
        {shuffledPosts.slice(0, 2).map((item: any, index: number) => {
          const category = item.tags.nodes[0]?.slug || 'uncategorized';
          const fullHref = isEnglish
            ? `/en/${category.toLowerCase()}/${item.slug}`
            : `/${category.toLowerCase()}/${item.slug}`;
          return (
            <SingleBlogCard
              key={index}
              title={item.title}
              date={item.date}
              excerpt={item.excerpt}
              imageUrl={item.featuredImage?.node?.sourceUrl}
              href={fullHref}
              tag={item.tags}
            />
          );
        })}
      </SimpleGrid>
    </Box>
  );
};

export default RelatedPost;
